export default __webpack_public_path__ + "static/media/link_circle.fd22ad0b.svg";